// import { searchTagList, getTagList, saveTag,deleteAboutTag } from "@/api/community";
import axios from "@/libs/axios.js";
import GacNioBridge from '@/libs/bridge'
export default function() {
  return {
    data() {
      return {
        currentHref: window.location.href,
        timeLeftJump: 0,
        platform:'',
        wxShare:{
          wxTitle:'预约试驾合创 007',
          wxShareImg:'https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20200917151726952-%3F%3F%3F%3F%3F%3F%3F%403x.png',
          wxDesc:'智能电动全能SUV等你来试~',
        }
      
      };
    },
    created() {
      GacNioBridge.platform().then((res) => {
        //res: ios android miniprogram WXH5 4种环境
        this.platform = res || ''
        console.log(`当前平台-------${res}`)
      })
    },
    mounted() {
      this.getH5Sign().then(res => {
        let result = res.data.data;
        let timer = setInterval(() => {
          if (typeof wx === "object" && this.renderData.wxTitle) {
          
            clearInterval(timer);
            timer = null;
            let wxShare = {
              wxTitle:this.renderData.wxTitle,
              wxShareImg:this.renderData.wxShareImg,
              wxDesc:this.renderData.wxDesc,
            }
            this.$set(this, 'wxShare', wxShare)
            wx.config({
              debug: false, //默认为false 为true的时候是调试模式，开启调试模式,调用的所有api的返回值会在客户端alert出
              appId: result.appId, //必填，公众号的唯一标识
              timestamp: result.timestamp, // 必填，生成签名的时间戳
              nonceStr: result.nonceStr, // 必填，生成签名的随机串
              signature: result.signature, // 必填，签名
              // 必填，需要使用的JS接口列表
              jsApiList: [
                "checkJsApi",
                "onMenuShareWeibo",
                "updateAppMessageShareData",
                "updateTimelineShareData"
                // 旧接口
                // 'onMenuShareTimeline',
                // 'onMenuShareAppMessage',
              ]
            });
            //配置自定义分享内容
            let share_config = {
              title: this.wxShare.wxTitle, // 这是分享展示卡片的标题
              desc: this.wxShare.wxDesc, // 这是分享展示的摘要
              link: this.currentHref, // 这里是分享的网址
              imgUrl: this.wxShare.wxShareImg, // 这里是需要展示的图标
              success: function(rr) {
              }, cancel: function(tt) { }, fail: function(tt) { }
            };

            // config
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: [
                  "updateAppMessageShareData",
                  "updateTimelineShareData",
                  "onMenuShareWeibo"
                ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                }
              });
              wx.updateAppMessageShareData(share_config);
              wx.updateTimelineShareData(share_config);
              wx.onMenuShareWeibo(share_config);
              // wx.onMenuShareTimeline(share_config);
              // wx.onMenuShareAppMessage(share_config);
            });
            wx.error(function(err) {
            });
          }
        }, 100);
      });
    },
    watch: {
    },
    methods: {
      afterSuccess() {
        console.log('预约成功执行')
        this.showSuccess = true
        this.timeLeftJump = 4
        let timer = setInterval(() => {
          if (this.timeLeftJump <= 1) {
           if(!this.unClick){this.goLivepage()}
            clearInterval(timer)
          }
          this.timeLeftJump--
        }, 1000)
      },
      goLivepage() {
        let jumpParams = {
          url:
            '/pages/community-package/cloud-exhibition/cloud-exhibition-index/cloud-exhibition-index',
          type: 37,
          jumpUrlParam: [],
        }
        switch (this.platform) {
          // 可识别 ios android miniprogram WXH5
          case 'android':
            GacNioBridge.callApp('router', jumpParams)
            this.showSuccess = false
            break
          case 'ios':
            GacNioBridge.callApp('router', jumpParams)
              this.showSuccess = false
            break
          case 'miniprogram':
            window.wx && window.wx.miniProgram.navigateTo({
              url: `/pages/community-package/cloud-exhibition/cloud-exhibition-index/cloud-exhibition-index`,
            })
              this.showSuccess = false
            break
          case 'WXH5':
            console.log('h5前往小程序');
            break
  
          default:
            console.log('展示二维码')
            break
        }
      },
      getH5Sign() {
        return axios({
          method: "get",
          url: `/commserv/h5/noAuth/front/v3.2.45/getH5Sign?url=${encodeURIComponent(this.currentHref)}`,
          data: {},
          headers: {
            Authorization: "null",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
      }
    }
  };
}
